import { render } from "./resourceCenterViewer.vue?vue&type=template&id=7ec555f0&ts=true"
import script from "./resourceCenterViewer.ts?vue&type=script&lang=ts"
export * from "./resourceCenterViewer.ts?vue&type=script&lang=ts"

import "./resourceCenterViewer.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__